import React, { Component } from 'react';
import axios from 'axios'
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import { Button, Divider, Form } from 'semantic-ui-react'
import * as moment from 'moment';
import { base, serverIp, getOrderKey, toCurrency, pythonApiIp, whatsapp_api_glassfish } from '../../../../config/constants';
import * as UiConsts from '../../../../config/UiConstants.js'

export class ResendMessage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order_num: '',
            totalOrderAmount: '',
            depositAmount: '',
            balance: '',
            phone: this.props.phone,
            loading: false,
            visible: true,
        }
    }

    resendMessage = () => {
        console.log("++++++ sendToDepRequested +++")
        if (!this.props.message.key) {
            alert("no this.props.message.key")
        } else {

            this.setState({ loading: true })

            var d = new Date();
            let now = moment().format('MMMM Do, h:mm:ss a');

            axios.post(whatsapp_api_glassfish + 'resendMessage', {
                apiKey: "resendMessage",
                messageId: this.props.message.key,
                enteredBy: this.props.user,
            })
                .then((response) => {
                    this.setState({ loading: false })
                    console.log(response.data);


                })
                .catch((error) => {
                    console.log(error);
                    this.setState({ loading: false })
                });
        }
    }

    render() {

        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>
              
                    <Button fluid color='red' onClick={this.resendMessage}> RESEND </Button>
                
            </div>
        )
    }
}

export default ResendMessage;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Whatsapp/ResendMessage.js